import { Route, Routes } from 'react-router-dom';
import { Courses } from './components/Courses/Courses';
import { CreateCourse } from './components/CreateCourse/CreateCourse';


export const CoursesPage = () => {

    // ### State
    
    // ### Effects

    // ### Functions

    // ### Views

    return(
        <Routes>
            <Route index element={<Courses />} />
            <Route path="/create" element={<CreateCourse />} />
        </Routes>
    )
}